import _extends from "@babel/runtime/helpers/extends";
/**
 * This file contains export components and API for FlexibleCard components.
 * For internal usage for access to all available props, please use following
 * - ./components/elements for metadata component
 * - ./components/actions for action component
 *
 * DO NOT add a new prop to these components until we are ready to support it externally.
 */
import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { SmartLinkSize } from '../../constants';
import { CopyLinkAction as CopyLinkActionComponent, CustomAction as CustomActionComponent, DownloadAction as DownloadActionComponent, FollowAction as FollowActionComponent, PreviewAction as PreviewActionComponent, UnresolvedAction as UnresolvedActionComponent } from './components/actions';
import { AssignedTo, AssignedToGroup, AttachmentCount, AuthorGroup, ChecklistProgress, CollaboratorGroup, CommentCount, CreatedBy, CreatedOn, DueOn, LatestCommit, LinkIcon, Location, ModifiedBy, ModifiedOn, OwnedBy, OwnedByGroup, Preview, Priority, ProgrammingLanguage, Provider, ReactCount, ReadTime, SentOn, Snippet, SourceBranch, State, StoryPoints, SubscriberCount, SubTasksProgress, TargetBranch, Title, ViewCount, VoteCount } from './components/elements';
// ---- EXPORTED METADATA COMPONENT ---- //
export var AssignedToElement = function AssignedToElement() {
  return /*#__PURE__*/React.createElement(AssignedTo, null);
};
export var AssignedToGroupElement = function AssignedToGroupElement() {
  return /*#__PURE__*/React.createElement(AssignedToGroup, null);
};
export var AttachmentCountElement = function AttachmentCountElement() {
  return /*#__PURE__*/React.createElement(AttachmentCount, null);
};
export var AuthorGroupElement = function AuthorGroupElement() {
  return /*#__PURE__*/React.createElement(AuthorGroup, null);
};
export var ChecklistProgressElement = function ChecklistProgressElement() {
  return /*#__PURE__*/React.createElement(ChecklistProgress, null);
};
export var CollaboratorGroupElement = function CollaboratorGroupElement() {
  return /*#__PURE__*/React.createElement(CollaboratorGroup, null);
};
export var CommentCountElement = function CommentCountElement(props) {
  if (fg('platform-linking-additional-flexible-element-props')) {
    return /*#__PURE__*/React.createElement(CommentCount, {
      color: props === null || props === void 0 ? void 0 : props.color
    });
  }
  return /*#__PURE__*/React.createElement(CommentCount, null);
};
export var CreatedOnElement = function CreatedOnElement() {
  return /*#__PURE__*/React.createElement(CreatedOn, null);
};
export var CreatedByElement = function CreatedByElement() {
  return /*#__PURE__*/React.createElement(CreatedBy, null);
};
export var DueOnElement = function DueOnElement() {
  return /*#__PURE__*/React.createElement(DueOn, null);
};
export var LatestCommitElement = function LatestCommitElement() {
  return /*#__PURE__*/React.createElement(LatestCommit, null);
};
export var LinkIconElement = function LinkIconElement(props) {
  if (fg('platform-linking-additional-flexible-element-props')) {
    return /*#__PURE__*/React.createElement(LinkIcon, {
      size: (props === null || props === void 0 ? void 0 : props.iconTileSize) === 24 ? SmartLinkSize.Large : SmartLinkSize.Medium,
      render: props === null || props === void 0 ? void 0 : props.render
    });
  }
  return /*#__PURE__*/React.createElement(LinkIcon, null);
};
export var LocationElement = function LocationElement() {
  return /*#__PURE__*/React.createElement(Location, null);
};
export var ModifiedByElement = function ModifiedByElement() {
  return /*#__PURE__*/React.createElement(ModifiedBy, null);
};
export var ModifiedOnElement = function ModifiedOnElement(props) {
  if (fg('platform-linking-additional-flexible-element-props')) {
    return /*#__PURE__*/React.createElement(ModifiedOn, {
      hideDatePrefix: props === null || props === void 0 ? void 0 : props.hideDatePrefix,
      color: props === null || props === void 0 ? void 0 : props.color
    });
  }
  return /*#__PURE__*/React.createElement(ModifiedOn, null);
};
export var OwnedByElement = function OwnedByElement(props) {
  if (fg('platform-linking-additional-flexible-element-props')) {
    return /*#__PURE__*/React.createElement(OwnedBy, {
      hideFormat: props === null || props === void 0 ? void 0 : props.hideFormat,
      color: props === null || props === void 0 ? void 0 : props.color
    });
  }
  return /*#__PURE__*/React.createElement(OwnedBy, null);
};
export var OwnedByGroupElement = function OwnedByGroupElement() {
  return /*#__PURE__*/React.createElement(OwnedByGroup, null);
};
export var PreviewElement = function PreviewElement(props) {
  if (fg('platform-linking-additional-flexible-element-props')) {
    return /*#__PURE__*/React.createElement(Preview, {
      overrideUrl: props === null || props === void 0 ? void 0 : props.url
    });
  }
  return /*#__PURE__*/React.createElement(Preview, null);
};
export var PriorityElement = function PriorityElement() {
  return /*#__PURE__*/React.createElement(Priority, null);
};
export var ProgrammingLanguageElement = function ProgrammingLanguageElement() {
  return /*#__PURE__*/React.createElement(ProgrammingLanguage, null);
};
export var ProviderElement = function ProviderElement() {
  return /*#__PURE__*/React.createElement(Provider, null);
};
export var ReactCountElement = function ReactCountElement(props) {
  if (fg('platform-linking-additional-flexible-element-props')) {
    return /*#__PURE__*/React.createElement(ReactCount, {
      color: props === null || props === void 0 ? void 0 : props.color
    });
  }
  return /*#__PURE__*/React.createElement(ReactCount, null);
};
export var ReadTimeElement = function ReadTimeElement() {
  return /*#__PURE__*/React.createElement(ReadTime, null);
};
export var SentOnElement = function SentOnElement() {
  return /*#__PURE__*/React.createElement(SentOn, null);
};
export var SnippetElement = function SnippetElement(props) {
  return /*#__PURE__*/React.createElement(Snippet, {
    maxLines: props.maxLines,
    content: props.text
  });
};
export var SourceBranchElement = function SourceBranchElement() {
  return /*#__PURE__*/React.createElement(SourceBranch, null);
};
export var StateElement = function StateElement() {
  return /*#__PURE__*/React.createElement(State, null);
};
export var StoryPointsElement = function StoryPointsElement() {
  return /*#__PURE__*/React.createElement(StoryPoints, null);
};
export var SubscriberCountElement = function SubscriberCountElement() {
  return /*#__PURE__*/React.createElement(SubscriberCount, null);
};
export var SubTasksProgressElement = function SubTasksProgressElement() {
  return /*#__PURE__*/React.createElement(SubTasksProgress, null);
};
export var TargetBranchElement = function TargetBranchElement() {
  return /*#__PURE__*/React.createElement(TargetBranch, null);
};
export var TitleElement = function TitleElement(props) {
  return /*#__PURE__*/React.createElement(Title, _extends({
    hideTooltip: props === null || props === void 0 ? void 0 : props.hideTooltip,
    maxLines: props === null || props === void 0 ? void 0 : props.maxLines,
    target: props === null || props === void 0 ? void 0 : props.target
  }, props !== null && props !== void 0 && props.text ? {
    text: props === null || props === void 0 ? void 0 : props.text
  } : undefined));
};
export var ViewCountElement = function ViewCountElement() {
  return /*#__PURE__*/React.createElement(ViewCount, null);
};
export var VoteCountElement = function VoteCountElement() {
  return /*#__PURE__*/React.createElement(VoteCount, null);
};

// ---- EXPORTED ACTION COMPONENTS ---- //

export var toActionProps = function toActionProps(props) {
  var _props$appearance;
  return {
    appearance: (_props$appearance = props === null || props === void 0 ? void 0 : props.appearance) !== null && _props$appearance !== void 0 ? _props$appearance : 'default',
    icon: undefined
  };
};
export var CopyLinkAction = function CopyLinkAction(props) {
  return /*#__PURE__*/React.createElement(CopyLinkActionComponent, toActionProps(props));
};
export var CustomAction = function CustomAction(props) {
  return /*#__PURE__*/React.createElement(CustomActionComponent, _extends({}, toActionProps(props), {
    content: props === null || props === void 0 ? void 0 : props.children,
    onClick: props === null || props === void 0 ? void 0 : props.onClick
  }));
};
export var DownloadAction = function DownloadAction(props) {
  return /*#__PURE__*/React.createElement(DownloadActionComponent, toActionProps(props));
};
export var FollowAction = function FollowAction(props) {
  return /*#__PURE__*/React.createElement(FollowActionComponent, toActionProps(props));
};
export var PreviewAction = function PreviewAction(props) {
  return /*#__PURE__*/React.createElement(PreviewActionComponent, toActionProps(props));
};
export var UnresolvedAction = function UnresolvedAction() {
  return /*#__PURE__*/React.createElement(UnresolvedActionComponent, null);
};